import React from 'react';
import { Stack, Typography, lighten } from '@mui/material';
import { OrderTypeButton } from '../../utilities/styles/checkoutPage.style';

// Define the props interface
interface OrderTypeSelectorProps {
  orderType?: string | undefined;
  organizationSettings: {
    enablePickupOrders?: boolean;
    enableDeliveryOrders?: boolean;
    enableEventOrders?: boolean;
    layoutColor?: string;
  };
  onOrderTypeChange: (type: 'Pickup' | 'Delivery' | 'Event') => void;
}

// Styled button component (you can also keep OrderTypeButton if it's already defined)
// const OrderTypeButton = Button;

const OrderTypeSelector: React.FC<OrderTypeSelectorProps> = ({
  orderType,
  organizationSettings,
  onOrderTypeChange,
}) => {

   const handleOrderTypeChange = (type: 'Pickup' | 'Delivery' | 'Event') => {
    onOrderTypeChange(type);
  };

  const getButtonStyles = (type: string) => {
    const isActive = orderType === type;
    const { layoutColor } = organizationSettings;

    if (isActive) {
      return {
        color: 'layoutColor.contrastText',
        backgroundColor: layoutColor,
        '&.MuiButton-root:hover': {
          backgroundColor: layoutColor,
        },
      };
    }

    return {
      backgroundColor: layoutColor && lighten(layoutColor, 0.5),
      '&.MuiButton-root:hover': {
        backgroundColor: layoutColor && lighten(layoutColor, 0.5),
      },
    };
  };

  // Helper function to render a button
  const renderOrderTypeButton = (
    type: 'Pickup' | 'Delivery' | 'Event',
    enabled?: boolean
  ) => {
    if (!enabled) return null;

    return (
      <OrderTypeButton
        disableRipple={true}
        sx={getButtonStyles(type)}
        onClick={() => handleOrderTypeChange(type)}
      >
        <Typography sx={{ fontSize: { sm: '20px' } }}>
          {type}
        </Typography>
      </OrderTypeButton>
    );
  };

  return (
    <Stack gap={3} direction="row">
      {renderOrderTypeButton('Pickup', organizationSettings?.enablePickupOrders)}
      {renderOrderTypeButton('Delivery', organizationSettings?.enableDeliveryOrders)}
      {renderOrderTypeButton('Event', organizationSettings?.enableEventOrders)}
    </Stack>
  );
};

export default OrderTypeSelector;